const { REACT_APP_BACKOFFICE_CONNECTION, REACT_APP_BACKOFFICE_FILE_UPLOAD_PATH } = process.env;

export const INDICATOR_TYPE_PROCESS = 'Proceso'
export const INDICATOR_TYPE_RESULTS = 'Resultados'
export const INDICATOR_TYPE_STRUCTURAL = 'Estructurales'
export const UPLOAD = '/uploads/'
export const ODS = 'ods';
export const GROUPS = 'grupos-prioritarios';
export const TODOS = 'todos';
export const messages = {
    map: 'El mapa no tiene datos para el periodo seleccionado.',
    chart: 'El gráfico no tiene datos disponibles para el periodo seleccionado.',
};

export const LIMIT_PAGINATION_OPEN_DATA = 10;
export const VALID_SEARCH_REGEX = /^[A-Za-zÁÉÍÓÚÜáéíóúü0-9]+([ .,]?[A-Za-zÁÉÍÓÚÜáéíóúü0-9]+)*[.,]?$/;

export const GRAFICO_BARRA = 1;
export const GRAFICO_BARRA_APILABLE = 2;
export const GRAFICO_BARRA_AGRUPADA = 3;
export const GRAFICO_TORTA = 5;
export const GRAFICO_LINEAL = 4;
export const MAPA = 6
export const MAPA_CALOR = 7
export const GRAFICO_DOBLE_EJE_Y = 8;

export const FUENTE_OPEN_DATA = 'Fuente: Indicador Monitor de Derechos. Defensoría del Pueblo de la Ciudad de Buenos Aires';

export const SEARCH_MODE_EXPANDED = "expanded";
export const SEARCH_MODE_PREDICTIVE = "predictive";

export const LETTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

export const API_FILES_BASE_URL = `${REACT_APP_BACKOFFICE_CONNECTION}${REACT_APP_BACKOFFICE_FILE_UPLOAD_PATH}`;